import React, { useEffect } from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BonusSection } from '../components/BonusSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-white font-sans text-stone-900" data-id="element-329">
      <nav className="bg-white border-b border-stone-100 py-4 sticky top-0 z-50" data-id="element-330">
        <div className="container mx-auto px-4 flex justify-between items-center" data-id="element-331">
          <span className="font-serif font-bold text-xl text-stone-900 tracking-tight" data-id="element-332">
            Mil Hojas <span className="text-amber-600" data-id="element-333">Pro</span>
          </span>
        </div>
      </nav>

      <main data-id="element-334">
        <HeroSection data-id="element-335" />
        <ProblemSection data-id="element-336" />
        <SolutionSection data-id="element-337" />
        <BenefitsSection data-id="element-338" />
        <TestimonialsSection data-id="element-339" />
        <BonusSection data-id="element-340" />
        <OfferSection data-id="element-341" />
      </main>

      <Footer data-id="element-342" />
    </div>;
}